import { render, staticRenderFns } from "./text-element.vue?vue&type=template&id=61c12714&"
import script from "./text-element.vue?vue&type=script&lang=js&"
export * from "./text-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports